import { useContext } from 'react';

import { _FormFieldContext } from '../contexts/FormFieldContext.js';
import type { SharedFormFieldContextProps } from '../contexts/FormFieldContext.js';

/**
 * Return type of `useFormFieldContext`. Custom context values may omit
 * registration helpers and the member-id array; the hook fills in defaults so
 * consumers can rely on them being present.
 * @internal
 */
export type FormFieldContextValue = SharedFormFieldContextProps & {
  memberFormControlIds: string[];
  registerFormControlId: (id: string) => () => void;
  registerMemberFormControlId: (id: string) => () => void;
  registerFormFieldLabelId: (id: string) => () => void;
};

/**
 * @internal
 */
export const useFormFieldContext = (): FormFieldContextValue => {
  const context = useContext(
    _FormFieldContext,
  ) as Partial<SharedFormFieldContextProps>;

  return {
    memberFormControlIds: [],
    registerFormControlId: () => () => undefined,
    registerMemberFormControlId: () => () => undefined,
    registerFormFieldLabelId: () => () => undefined,
    ...context,
  } as FormFieldContextValue;
};
